import { render, staticRenderFns } from "./ServiceDashboardTopologyEdit.vue?vue&type=template&id=2b00cf31"
import script from "./ServiceDashboardTopologyEdit.vue?vue&type=script&lang=js"
export * from "./ServiceDashboardTopologyEdit.vue?vue&type=script&lang=js"
import style0 from "./ServiceDashboardTopologyEdit.vue?vue&type=style&index=0&id=2b00cf31&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports